import { TooltipInfo } from '@shop/frontend/web/js/components/TooltipInfo';
import { InteractPlan } from '@shop/frontend/web/js/components/InteractPlan';
import { eventHelper } from '@frontend/web/src/js/helpers/EventHelper';
import { EventEmitter } from '@shop/frontend/web/js/components/EventEmitter';
import { arrayHelper } from '@shop/frontend/web/js/helpers/ArrayHelper';
import api from '@shop/frontend/web/js/api';
import { SvgPlacesManager } from '@shop/frontend/web/js/services/SvgPlacesManager';
import { helpers } from '@shop/frontend/web/js/helpers';
import PriceLegend from '../PriceLegend.js';
import { EventInteractPlanView } from './EventInteractPlanView.js';
import { EventInteractPlanModel } from './EventInteractPlanModel.js';
import { emits } from './EventInteractPlanEnum.js';

export class EventInteractPlan {
  constructor() {
    /** @module EventEmitter */
    this.emitter = null;

    this.tooltipInfo = new TooltipInfo();
    /** @module SvgPlacesManager */
    this.svgPlacesManager = null;

    /** @module InteractPlan */
    this.stadiumPlan = null;
    this.stadiumPriceLegend = new PriceLegend();

    /** @module InteractPlan */
    this.sectorPlan = null;
    this.sectorPriceLegend = new PriceLegend({
      containerClassName: 'js-places-prices',
    });

    this.view = new EventInteractPlanView();
    this.model = new EventInteractPlanModel();

    this.autoOpenSector = true;
  }

  /**
     * @param params {Object}
     * @param params.model {Object}
     * @param params.settings {Object}
     * @param params.useStorage {Boolean}
     * @param params.storageLimit {Number}
     * @param params.$svgWrapper {HTMLElement}
     * @param params.onLoadStadium {Function}
     * @param params.onTapOnSector {Function}
     * @param params.onLoadSector {Function}
     * @param params.tapOnPlace {Function}
     */
  init(params) {
    this.svgPlacesManager = new SvgPlacesManager({
      useStorage: params.useStorage !== false,
    });
    if (params.storageLimit) this.svgPlacesManager.setStorageLimit(params.storageLimit);

    this.initEventEmitters();

    this.model.eventId = params.model.eventId;
    this.model.unitId = params.model.unitId;
    this.model.zones = params.model.zones || [];
    this.model.prices = params.model.prices || [];

    if (params.settings) {
      this.model.settings.validateAndAddSettings(params.settings);
      if (params.settings.autoOpenSector === false) this.autoOpenSector = false;
    }
    this.view.setPlaceToSvg(params.$svgWrapper);

    /* Events */
    if (params.onLoadStadium) {
      this.emitter.subscribe(emits.AFTER_LOAD_STADIUM, (data) => params.onLoadStadium(data));
    }
    if (params.onTapOnSector) {
      this.emitter.subscribe(emits.TAP_ON_SECTOR, (viewId) => params.onTapOnSector(viewId));
    }
    if (params.onLoadSector) {
      this.emitter.subscribe(emits.AFTER_LOAD_SECTOR, (data) => params.onLoadSector(data));
    }
    if (params.tapOnPlace) {
      this.emitter.subscribe(emits.TAP_ON_PLACE, (place) => {
        params.tapOnPlace(place);
      });
    }

    /* Init plans */
    if (eventHelper.isStadiumPlan()) {
      if (this.model.settings.isPlanPriceFilterById()) this.setZoneIdsToSectors();

      if (this.model.zones.length > 0) this.renderStadiumPriceLegend();

      this.initStadiumPlan();

      if (eventHelper.hasPlanPlaces()) {
        // На случаи когда в плане отображаются одновременно места
        api.event.getPrices({ 
          eventId: this.model.getEventId(),
          viewId: 'main',
        }).then((res) => {
          if (!res.prices) return alert('Не удалось получить ценовые зоны!');
          eventHelper.setAttributesToPlaces({
            prices: res.prices,
            zones: res.zones,
          });
        });
      }
      $('#js-places-back-playbill').addClass('active back_left');
    } else {
      $('#js-places-back-playbill').addClass('d-flex justify-content-center');
      $('#js-places').addClass('active');
      $('#js-interact-plan-info').removeClass('interact-plan-info_sector');
      this.initSectorPlan();
    }
  }

  initEventEmitters() {
    this.emitter = new EventEmitter();

    this.stadiumPlan = new InteractPlan();
    this.sectorPlan = new InteractPlan();

    this.setUpSubscribers();
    this.setUpListeners();
  }

  renderStadiumPriceLegend(zones, params = { usePrimaryColor: true }) {
    if (zones) this.model.zones = zones;

    this.stadiumPriceLegend.render(this.model.zones, {
      usePrimaryColor: !!params.usePrimaryColor,
      showFreePlaces: this.model.settings.showFreePlaces,
      mobileLastSlot: this.view.getMobileStadiumPlacesInfo(),
      joinEqualPrices: !this.model.settings.isPlanPriceFilterById(),
    });
  }

  setZoneIdsToSectors() {
    api.event.getZonesGroupedByViews({ eventId: this.model.getEventId() }).then((res) => {
      if (!res.zones) return false;
      Object.keys(res.zones).forEach((viewId) => {
        $(`[view_id=${viewId}]`).attr('data-zone-id', res.zones[viewId].join(','));
      });
    });
  }

  showStadiumPlan() {
    /* Выводим стадион */
    this.view.renderSvgPlan(this.model.stadiumSvg);

    this.initStadiumPlan();
  }

  setActivePlaces(carts) {
    eventHelper.setActivePlaces(carts);
  }

  removeActivePlaces(carts) {
    eventHelper.removeActivePlaces(carts);
  }

  setActivePlaceBySid(sid) {
    eventHelper.setActivePlaceBySid(sid);
  }

  removeActivePlaceBySid(sid) {
    eventHelper.removeActivePlaceBySid(sid);
  }

  showZonesLoader() {
    return this.stadiumPriceLegend.renderHtml(this.getZonesLoader());
  }

  showSectorZonesLoader() {
    return this.sectorPriceLegend.renderHtml(this.getZonesLoader());
  }

  renderSvgPlan(svg) {
    this.view.renderSvgPlan(svg);
  }

  disablePlan() {
    this.disableSectorsAndPlaces();
    // todo:вынести в priceLegend
    $('.js-stadium-zones input[type=checkbox]').prop('disabled', true);
    $('.js-places-prices input[type=checkbox]').prop('disabled', true);
    $('#js-places-back').prop('disabled', true);
  }

  enablePlan() {
    this.enableSectorsAndPlaces();
    $('.js-stadium-zones input[type=checkbox]').prop('disabled', false);
    $('.js-places-prices input[type=checkbox]').prop('disabled', false);
    $('#js-places-back').prop('disabled', false);
  }

  disableSectorsAndPlaces() {
    return $('g[mode]').addClass('disabled');
  }

  enableSectorsAndPlaces() {
    return $('g[mode]').removeClass('disabled');
  }

  enableSectorByViewId(viewId) {
    return $(`g[view_id=${viewId}]`).removeClass('disabled');
  }

  enablePlaceBySid(sid) {
    return $(`g[id=${sid}]`).removeClass('disabled');
  }

  getSpinnerTemplate() {
    return `<div style="min-height: 300px; width: 100%;">
              <div class="spinner spinner_primary">
                <div class="spinner__bounce spinner__bounce_first"></div>
                <div class="spinner__bounce spinner__bounce_second"></div>
                <div class="spinner__bounce spinner__bounce_third"></div>
              </div>
            </div>`;
  }

  getZonesLoader() {
    return `<div class="skeleton-box skeleton-box_price-legend"></div>
            <div class="skeleton-box skeleton-box_price-legend"></div>
            <div class="skeleton-box skeleton-box_price-legend"></div>`;
  }

  /* Инициализция подписчиков */
  setUpSubscribers() {
    /**
         * При нажатии на сектор загружает план, цены
         * @event SubscriptionController#event:tap-on-sector
         * @property {Number} viewId
         */
    this.emitter.subscribe('event:tap-on-sector', (viewId) => {
      if (!this.autoOpenSector) return false;

      this.openSector(viewId);
      this.showLoader();
      $('#js-places-back-playbill').removeClass('active back_left');

      this.svgPlacesManager
        .getSvgPlaces(this.model.eventId, viewId, this.model.unitId)
        .then((res) => {
          if (!res.svg) return alert('Не удалось загрузить схему сектора!');
          if (!res.zones) return alert('Не удалось загрузить ценовые зоны!');

          this.view.renderSvgPlan(res.svg);
          $('.places__svg').addClass('skeleton-loader');
          this.initSectorPlan();

          this.showSectorZonesLoader();

          this.svgPlacesManager
            .getPrices(this.model.eventId, viewId)
            .then(({ prices, zones }) => {
              this.model.zones = zones;
              this.model.prices = prices;
              this.updatePlacesPrices({
                places_params: res.places_params,
              });
              $('.places__svg').removeClass('skeleton-loader');

              this.svgPlacesManager.saveToStorage(
                this.model.unitId,
                viewId,
                this.model.eventId,
              );
              this.emitter.emit('event:after-load-sector', {
                ...res,
                prices,
                viewId,
              });
            });
        });
    });
  }

  loadPlacesPrices({ viewId, clearCache }) {
    $('.places__svg').addClass('skeleton-loader');
    this.showSectorZonesLoader();
    this.svgPlacesManager
      .updatePricesHandler(this.model.eventId, viewId, clearCache)
      .then(({ prices, zones }) => {
        this.model.zones = zones;
        this.model.prices = prices;
        this.updatePlacesPrices();
        $('.places__svg').removeClass('skeleton-loader');

        this.svgPlacesManager.saveToStorage(this.model.unitId, viewId, this.model.eventId);
      });
  }

  openSector(viewId, sectorData = {}) {
    this.model.currentViewId = viewId;
    this.model.prices = sectorData.prices || [];
    this.model.zones = sectorData.zones || [];
    if (!this.model.stadiumSvg) this.model.stadiumSvg = this.view.$placeToSvg.html();

    this.tooltipInfo.hide();
    this.showSectorInfo();

    if (sectorData.svg) {
      this.view.renderSvgPlan(sectorData.svg);
      this.initSectorPlan(sectorData);
    }

    this.showSectorPriceLegend();
  }

  showSectorPriceLegend() {
    this.stadiumPriceLegend.hide();
    this.sectorPriceLegend.show();
  }

  showSectorInfo() {
    /* todo:подумать над этим, пока тут */
    $('#js-places-legend').hide();
    $('#js-places-choose').show();
    $('#js-places-warning').show();
    if (this.model.stadiumSvg) $('#js-places-back').addClass('active');
    $('#js-places-change').addClass('openedSector');
    $('#js-places-info').removeClass('places__info_sector');
    $('.interact-plan-info').removeClass('interact-plan-info_sector');
  }

  showLoader() {
    this.view.renderSvgPlan(this.getSpinnerTemplate());
  }

  initStadiumPlan() {
    /* подумать над этим пока тут */
    $('#js-places').addClass('active');
    $('#js-places-legend').show();
    $('#js-places-choose').hide();
    $('#js-places-warning').hide();
    $('#js-places-back').removeClass('active');
    $('#js-places-change').removeClass('openedSector');
    $('.interact-plan-info').addClass('interact-plan-info_sector');

    eventHelper.disableZeroPriceSectors($(this.view.$placeToSvg).find('g[view_id]'));

    this.sectorPriceLegend.hide();
    this.stadiumPriceLegend.show();

    /* Добавляем интерактив стадиону */
    this.stadiumPlan.init(this.view.getLinkToSvg());

    this.emitter.emit('event:after-load-stadium');
  }

  /**
     * инициализация сектора стадиона
     */
  initSectorPlan() {
    if (this.model.prices.length > 0 && this.model.zones.length > 0) this.updatePlacesPrices();

    /* Добавляем интерактив сектору (инициализация) */
    this.sectorPlan.init(this.view.getLinkToSvg());
  }

  /**
     * @param {Object} [sectorData]
     * @param {Array} [sectorData.prices]
     * @param {Array} [sectorData.zones]
     * @param {Object} [sectorData.places_params]
     */
  updatePlacesPrices(sectorData = {}) {
    if (sectorData.prices) this.model.prices = sectorData.prices;
    if (sectorData.zones) this.model.zones = sectorData.zones;
    this.renderSectorPriceLegends();
    eventHelper.setAttributesToPlaces({
      prices: this.model.prices,
      zones: this.model.zones,
      places_params: sectorData.places_params,
    });
    if (!this.model.stadiumSvg) this.showSectorPriceLegend();
  }

  renderSectorPriceLegends() {
    const uniquePrices = arrayHelper.uniqueArrayByProperty(this.model.prices, 'z');
    const zones = eventHelper.getZonesByUniquePrices(uniquePrices, this.model.zones);
    this.sectorPriceLegend.render(zones, {
      mobileLastSlot: this.view.getMobilePlacesInfo(),
      isPlaces: true,
    });
  }

  /* Инициализция обработчиков */
  setUpListeners() {
    $(document).on('click', '#js-places-back', () => {
      // при отсутствии svg-стадиона переводит на страницу с афишей
      this.model.stadiumSvg ? this.showStadiumPlan() : $(location).attr('href', '/');
      $('#js-places-back-playbill').addClass('active back_left');
    });

    $(document).on('click', '#js-places-back-playbill', () => {
      $(location).attr('href', '/');
    });

    this.stadiumPlan.on('hover', (element) => {
      // при наведении на сектор показывает тултип
      if ($(element).closest('g[free]').length > 0) {
        const $activeSector = $(element).closest('g[free]');

        this.tooltipInfo.createTooltip({
          $element: $activeSector,
          name: eventHelper.getSectorNameOfGElement($activeSector),
          price: eventHelper.getSectorPriceOfGElement($activeSector),
          all: $activeSector.attr('count') || $activeSector.attr('all'),
          free: this.model.settings.showFreePlaces ? $activeSector.attr('free') : 0,
        });

        return this.tooltipInfo.show();
      }

      // при наведении на место показывает тултип
      if ($(element).closest('g.active').length > 0) {
        const $activePlace = $(element).closest('g.active');
        this.tooltipInfo.createTooltip({
          $element: $activePlace,
          name: $activePlace.attr('data-name'),
          price: `${$activePlace.attr('data-price')} ₽`,
        });

        return this.tooltipInfo.show();
      }

      return this.tooltipInfo.hide();
    });

    this.stadiumPlan.on('tap', (target) => {
      if (target.closest('g[view_id]').length) {
        this.stadiumPlan.resetTransform();
        /** @fires SubscriptionController#event:tap-on-sector */
        return this.emitter.emit(
          'event:tap-on-sector',
          parseInt(target.closest('g[view_id]').attr('view_id')),
        );
      }

      const $place = $(target).closest("g[mode='2']");
      if ($place.length) {
        if (!$place.hasClass('active')) return false;
        /** @fires EventInteractPlan#event:tap-on-place */
        return this.emitter.emit('event:tap-on-place', $place);
      }
    });

    this.sectorPlan.on('hover', (element) => {
      if ($(element).closest('g.active').length) {
        const $activePlace = $(element).closest('g.active');

        this.tooltipInfo.createTooltip({
          $element: $activePlace,
          name: $activePlace.attr('data-name'),
          price: `${$activePlace.attr('data-price')} ₽`,
        });

        this.tooltipInfo.show();
      } else {
        this.tooltipInfo.hide();
      }
    });

    this.sectorPlan.on('tap', (target) => {
      if (target.closest('g.active').length) {
        /** @fires EventInteractPlan#event:tap-on-place */
        this.emitter.emit('event:tap-on-place', $(target).closest('g.active'));
      }

      // если кликнули по вложенному сектору
      if (target.closest('g[view_id]').length) {
        /** @fires SubscriptionController#event:tap-on-sector */
        return this.emitter.emit(
          'event:tap-on-sector',
          parseInt(target.closest('g[view_id]').attr('view_id')),
        );
      }
    });

    /* Обработчик для фильтра по легендам цен */
    this.stadiumPriceLegend.on('change', (priceLegends) => {
      if (this.model.settings.isPlanPriceFilterById()) {
        this.view.renderSvgSectorsByZones(priceLegends);
      } else {
        this.view.renderSvgSectorsByPrices(priceLegends);
      }
    });
    this.stadiumPriceLegend.on('reset', () => this.view.renderSvgSectorsByPrices());
    this.sectorPriceLegend.on('change', (priceLegends) => {
      if (this.model.settings.isPlanPriceFilterById()) {
        this.view.renderSvgPlacesByZones(priceLegends);
      } else {
        this.view.renderSvgPlacesByPrices(priceLegends);
      }
    });

    // вспомогательная функция для привязки bind
    function hideTooltip() {
      this.tooltipInfo.hide();
    }

    $(window).on('scroll', helpers.debounce(hideTooltip.bind(this), 300));
  }
}
